import { logout } from '@app/modules/auth';

export const Strings = {
  sidebar: {
    home: 'Home',
    myMeals: 'My Meals',
    findARecipe: 'Find a Recipe',
    favorites: 'Favorites',

    dashboard: 'Dashboard',
    users: 'Users',
    players: 'Players',
    location: 'Locations',
    challenges: 'Challenges',
    rewardManagement: 'Reward Management',
    wishboneManagement: 'Wishbone Management',
    transactions: 'Transactions',
    notification: 'Notifications',
    logOut: 'Log Out',
    myProfile: 'My Profile',
  },
  field: {
    emailAddress: 'Email Address',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    mobile: 'Mobile Number',
    selectedAddress: 'Select Address',
    status: 'Status',
    name: 'Name',
    subtitle: 'Subtitle',
    image: 'Image',
    type: 'Type',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    contactNumber: 'Contact Number',
    file: 'File',
    price: 'Price',
    description: 'Description',
    searchDishes: 'Search Dishes...',
  },
  button: {
    ok: 'Ok',
    submit: 'Submit',
    login: 'Login',
    logout: 'Logout',
    forgetPassword: 'Forget Password ?',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    viewAll: 'View All',
    sort: 'Sort',
    save: 'Save',
    saveMyPreferences: 'Save My Preferences',
    findRecipe: 'Find a Recipe',
    getStarted: 'Get Started',
    haveAccount: 'Have Account',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Continue',
    backLogin: 'Back Login',
    reset: 'reset',
    clear: 'Clear',
  },
  header: {
    chef: `Chef's`,
    setPassword: 'Set Password',
    login: 'Login',
    forgotPassword: 'Forgot Password',
    rewardManagement: 'Reward Management',
  },
  auth: {
    logIn: 'Log In',
    signIn: 'Sign In',
    signInYour: 'Sign In to your account',
    signUp: 'Sign Up',
    signUpYour: 'Sign up to your account',
    forgotPassword: 'Forgot Password?',
    useYourOfficial: 'Use your official email id to login',
    forgotPasswordHeading: 'Forgot Password',
    enterYourEmail: 'Enter email to change your password',
    resetPassword: 'Reset password',
    enterAPassword: 'Enter a password to set it for your account',
    YourNewPassword: 'Your new password must be different from previous used password.',
    skip: 'Skip',
  },
  common: {
    searchNameEmailPhone: 'Search By Name, Email, Phone... ',
    copyright:
      '© 2024 All Rights Reserved. MOH Approval No. WQ48385 DOH Approval No. LAHA-2023-003385',
    developAutoResearch: '',
    success: 'Success!',
    failed: 'Failed!',
    selected: (prefix: string) => (prefix ? `${prefix} selected` : 'selected'),
    noRecord: 'No Record',
    pageNotFound: 'Page not found!',
    sorryCanNotFoundPage: 'Sorry, we couldn’t find the page you’re looking for.',
    search: 'Search...',
    delete: 'Delete',
    active: 'Active',
    inactive: 'Inactive',
    activeInactiveTitle: (isActive: boolean) => (isActive ? 'Inactive' : 'Active'),
    deleteCaption: (section: string) =>
      `Are you sure you want to delete this ${section}? This action can not be undone.`,
    activeInactiveCaption: (isActive: boolean, section: string) =>
      `Are you sure you want to ${
        isActive ? 'inactive' : 'active'
      } this ${section}? This action cannot be undone.`,
    update: 'Update',
    confirmLogout: 'Are you sure you want to Logout?',
    enterEmailAddress: 'Enter email address',
    IAccept: 'I accept',
    CookiesPolicy: 'Cookies,Policy Terms & Condition.',
    termsConditions: 'Terms and Privacy Policy',
    description: 'Description',
    addConfirmCaption: (section: string) => `Are you sure you want to add this ${section}?`,
    whatIngredients: `What ingredients do you have in your kitchen?`,
    noResultFound: 'No Result Found',
    dontHaveAccount: 'Don’t have an account yet?',
    haveAccount: 'Have an account?',
    itsNiceToHaveYouBack: 'Its nice to have you back!',
    createYourOwnAccountNow: 'Create your account now!',
    choosingToRegister: 'By choosing to register you agree to our ',
    receivePromotionalEmails: 'Receive promotional emails',
    receiveNotificationsMeal: `Receive notifications for meal updates, such as new trends, alternative meal options and new methods`,
    selectYourPreference:
      'Select your preferences below to unlock a world of personalized dishes and delightful culinary content crafted just for you.',
    favoriteCuisines: 'What are your favorite cuisines?',
    dietaryRestrictions: 'Do you have any dietary restrictions?',
    allergies: 'Do you have any allergies?',
    adventurousWithSpices: 'How adventurous are you with spice?',
    mealPrepTime: 'How much time do you prefer to spend on preparing a meal?',
    comfortLevel: `What's your comfort level in the kitchen?`,
    ingredientsNotes:
      'The quantity of ingredients mentioned below are for one serving. You will receive the quantity of ingredients as per your ordered quantity.',
  },
  validation: {
    fieldRequired: (field: string) => `Please enter the ${field}`,
    uploadRequired: (field: string) => `Please upload the ${field}`,
    selectRequired: (field: string) => `Please select the ${field}`,
    minNumber: (field: string) => `${field} must be an integer greater than or equal to 5`,
    invalidEmail: 'Please enter the valid email address',
    passwordNotMatch: 'Password and Confirm Password do not match',
    passwordMustContain: 'Password must contain at least 1 alphabet and 1 number',
    invalidMobileNumber: 'Please enter a valid Mobile Number for Exp:- +971XXXXXXXXX',
    invalidZipCode: 'Please enter the valid zip code',
  },
  rowActions: {
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    permissions: 'Permissions',
    remove: 'Remove',
  },
  pageTitle: {
    welcomeBack: 'Welcome Back!',
    signUp: 'Sign Up',
    recentlyViewed: 'Recently Viewed',
    filter: 'Filter',
    myProfile: 'My Profile',
    preferences: 'Preferences',
    notificationSettings: 'Notification Settings',
    helpFAQ: 'Help & FAQ',
    stores: 'Stores',
    myList: 'My List',
    sort: 'Sort',
  },
  users: {
    users: 'Users',
    userLevel: 'User Level',
    LocalUser: 'Local User',
    challengeCreated: 'Challenge Created',
    editUser: 'Edit User',
    updateUser: 'Update User',
    addUser: 'Add User',
    regionalCurator: 'Regional Curator',
  },
  selectedIngredients: {
    yourChoice: 'Your Choice of Ingredients',
  },
  onboard: {
    whatToCook: 'What to Cook?',
    leaveTheThinking: `Leave the thinking to us! We could help you to create a culinary dish that would dance on your palate. With the things from your kitchen lets journey through a unforgettable  `,
    chefs: 'CHEFS',
    basicIngredients: ` experience, where basic ingredients are transformed.`,
    skip: 'Skip',
    withMe: 'With the ',
    ingredients: 'INGREDIENTS',
    youHave: ` you have ${'\n'}`,
    findFood: 'Create Food You Love',
    weLoveFood: `We all want to indulge in an exquisite culinary ${'\n'} flavors –We love food.`,
    letUsHelp: 'Let us help you think like the ',
    thinkOutside: `, think outside ${'\n'} of the norm to make meals that you didn’t know ${'\n'} you could make in your own kitchen.`,
    welcome: 'Welcome to Chefs',
    elevateDining: `Elevate your dining experience by transcending ${'\n'} ordinary   meals into extraordinary feasts creating ${'\n'} a gastronomical delight! ${'\n'} Like the `,
    startCreation: 'Start Your Creation',
  },
};
